import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/**
 * External dependencies
 */
import { useContext, useEffect, useMemo, useState } from 'react';
import useFetch from '../hooks/useFetch';
import useMap from '../hooks/useMap';
import useWindowSize from '../hooks/useWindowSize';
import { SET_FILTERED_POSTS, SET_POSTS, store } from '../state/state';
import { latitudeSort } from './ExplorerMap';
import IconSprite from './IconSprite';
import Map from './Map';
import MapUI from './MapUI';
const url = `${window.mainSiteData.root}scenic-rim/v2/listings?`;
const ItineraryMap = ({ postIn }) => {
    const { height } = useWindowSize();
    const { ref, map, loaded: mapLoaded } = useMap();
    const [route, setRoute] = useState(null);
    const globalState = useContext(store);
    const { state, dispatch } = globalState;
    const { filteredPosts = [] } = state;
    const visibleFilteredPosts = useMemo(() => {
        return latitudeSort(filteredPosts || []);
    }, [filteredPosts]);
    const filterParams = useMemo(() => ({
        nonce: window.mainSiteData.nonce,
        postIn: postIn
    }), [postIn]);
    // Fetch centres
    const { data, error } = useFetch(url + new URLSearchParams(filterParams), {
        method: 'GET',
        headers: {
            'content-type': 'application/json',
            'X-WP-Nonce': window.mainSiteData.nonce
        },
    });
    // Update filtered posts when posts are stored in state
    useEffect(() => {
        dispatch({
            type: SET_FILTERED_POSTS,
            ...state,
            filteredPosts: state.posts
        });
    }, [state.posts]);
    // Update fetched centres in state
    useEffect(() => {
        if (!error && data) {
            dispatch({
                type: SET_POSTS,
                posts: data?.posts || []
            });
        }
    }, [data]);
    // Handle map data
    useEffect(() => {
        if (!visibleFilteredPosts.length)
            return;
        setRoute({
            path: 'places',
            meta: {
                title: 'Places to visit',
                variant: 'blue',
                homeCard: false,
                layer: {
                    title: 'Title',
                    intro: 'Intro',
                    icon: 'mountain',
                    posts: visibleFilteredPosts
                },
            },
        });
    }, [visibleFilteredPosts, setRoute]);
    const mapStyle = { opacity: 1, visibility: 'visible', height: 'auto' };
    return (_jsxs(_Fragment, { children: [_jsx(IconSprite, {}), _jsx("section", { children: _jsx("div", { style: mapStyle, children: _jsxs("div", { className: "relative w-full bg-grey-100", style: { height: height + 'px' }, children: [_jsx(Map, { mapRef: ref, loaded: mapLoaded }), mapLoaded && route && _jsx(MapUI, { map: map, routes: [route] })] }) }) })] }));
};
export default ItineraryMap;
